import {
  FormControl,
  InputLabel,
  MenuItem,
  ListSubheader as MuiListSubheader,
  Select,
  type SelectChangeEvent
} from '@mui/material';
import flatMap from 'lodash/flatMap';
import uniqueId from 'lodash/uniqueId';
import type React from 'react';
import { useMemo } from 'react';
import styled from 'styled-components';

export type SelectOption = {
  label: string;
  value: string;
};

export type SelectOptionGroup = {
  heading: string;
  options: SelectOption[];
};

export type PreviewLinkDropdownProps = {
  readonly label: string;
  readonly options: Array<SelectOption | SelectOptionGroup>;
  readonly onChange: (e: SelectChangeEvent) => void;
  readonly selected?: string;
};

const Dropdown = styled(FormControl)({
  width: '100%'
});

const ListSubheader = styled(MuiListSubheader)({
  opacity: 0.33
});

function renderOption({ label, value }: SelectOption): JSX.Element {
  return (
    <MenuItem key={value} value={value}>
      {label}
    </MenuItem>
  );
}

function renderGroup({ heading, options }: SelectOptionGroup): JSX.Element[] {
  return [<ListSubheader key={heading}>{heading}</ListSubheader>].concat(options.map(renderOption));
}

const PreviewLinkDropdown: React.FC<PreviewLinkDropdownProps> = (props: PreviewLinkDropdownProps) => {
  const { label, selected, options, onChange } = props;
  const id = useMemo(() => uniqueId('preview-link-dropdown-'), []);
  return (
    <Dropdown variant="standard">
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <Select value={selected} id={id} onChange={onChange}>
        {flatMap(options, (option) => ('options' in option ? renderGroup(option) : [renderOption(option)]))}
      </Select>
    </Dropdown>
  );
};

export default PreviewLinkDropdown;
